import { generateServiceId } from "@core/domains/identity";

export const GENERATION_SERVICE = {
  ID: generateServiceId("generation"),
  JOB_TYPES: { generation: "generation" },
  LABEL: "generation",
} as const;
